module.exports = __webpack_public_path__ + "img/art.c06853b3.jpg";